import { 
  Container, 
  Stack, 
  Typography, 
  Button, 
  Card, 
  TableContainer, 
  Table, 
  TableBody, 
  TableRow, 
  TableCell, 
  IconButton, 
  TablePagination,
  Paper,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Tooltip,
  Chip,
  Box,
  Grid
} from '@mui/material';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import Scrollbar from '../../../layouts/Scrollbar';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../../layouts/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MiscSkeleton from '../../../layouts/user/MiscSkeleton';
import { GetAll, apiURL } from '../../../utils/apiCalls';
import { filter } from 'lodash';
import EditIcon from '@mui/icons-material/Edit';
import SearchNotFound from '../../../layouts/SearchNotFound';
import Iconify from '../../../layouts/Iconify';
import { AgGridReact } from "ag-grid-react";
import { 
  AdminPanelSettings,
  PersonAdd,
  Business,
  Email,
  Phone,
  Edit,
  Add,
  FilterList,
  People,
  Security
} from '@mui/icons-material';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'emp_id', label: 'Emp. Id', align: 'left' },
  { id: 'first_name', label: 'Name', align: 'left' },
  { id: 'email', label: 'Email', align: 'left' },
  { id: 'phone', label: 'Phone Number', align: 'left' },
  { id: '', label: '', align: 'center' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => JSON.stringify(_user).toLowerCase().trim().indexOf(query.toLowerCase().trim()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const AdminList = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState();
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  async function GetList() {
    setLoading(true);
    const response = await GetAll(apiURL + '/api/v1/users/admin');
    console.log(response.data.data,"responseresponseresponse")
    if (response) {
      if (response.data.status) {
        setLoading(false);
        setList(response.data.data)
      }
      else {
        setLoading(false);
        toast.error(response.data.message)
        setList([])
      }
    }
    else {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetList();
  }, [])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = list.map((n) => n.exporter_company_Name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list.length) : 0;

  const filteredUsers = applySortFilter(list, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const handleClickEdit = (e) => {
    e.preventDefault();
  };

  const EditButton = (props) => {
    const handleClickEdit = (e) => {
      e.preventDefault();
      navigate(`/dashboard/adminUserRole/${props.data['id']}`)
    };
    return (
      <Tooltip title="Edit Admin">
        <IconButton 
          onClick={(e) => handleClickEdit(e)}
          sx={{
            background: '#1976d2',
            color: 'white',
            '&:hover': {
              background: '#1565c0',
              transform: 'scale(1.1)'
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          <Edit sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    )
  }

  // define columns and their respective fields
  const columnDefs = [
    {
      field: "emp_id",
      filter: "agTextColumnFilter",
      headerName: "Employee ID",
      cellStyle: { fontSize: '16px' },
      filterParams: {
        filterOptions: ["contains", "notContains", "startsWith", "endsWith"],
        suppressAndOrCondition: true
      }
    },
    {
      field: "first_name",
      filter: "agTextColumnFilter",
      headerName: "Name",
      cellStyle: { fontSize: '16px' },
      filterParams: {
        filterOptions: ["contains", "notContains", "startsWith", "endsWith"],
        suppressAndOrCondition: true
      }
    },
    {
      field: "role_designation",
      filter: "agTextColumnFilter",
      headerName: "Role",
      cellStyle: { fontSize: '16px' },
      filterParams: {
        filterOptions: ["contains", "notContains", "startsWith", "endsWith"],
        suppressAndOrCondition: true
      }
    },
    { field: "email", headerName: "Email", cellStyle: { fontSize: '16px' } },
    { field: "phone", headerName: "Phone", cellStyle: { fontSize: '16px' } },
    { field: "active", headerName: "IsActive", cellStyle: { fontSize: '16px' } },

    { field: 'edit', minWidth: 190, cellRenderer: EditButton }
  ];

  // column properties
  const autoGroupColumnDef = {
    minWidth: 200
  };

  // addded sort and filtering feature
  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true
  };

  //  handle tree
  const getDataPath = ({ id, ref_agent_id }) => {
    const result = [id];
    return result;
  };

  const gridRef = useRef();

  // handle search input
  const handleFilter = useCallback((event) => {
    setFilterName(event.target.value);
  }, []);


  return (
    <Container sx={{ m: 0, width: '100%', maxWidth: '100%' }} maxWidth={false}>
      <Fade in timeout={800}>
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
            <Avatar sx={{ 
              bgcolor: '#1976d2', 
              width: 48, 
              height: 48,
              boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
            }}>
              <AdminPanelSettings sx={{ fontSize: 24, color: 'white' }} />
            </Avatar>
            <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Admin Management
            </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Manage system administrators and procurement users
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2 }} />
        </Box>
      </Fade>

      <Zoom in timeout={600}>
        <Card sx={{ 
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          borderRadius: 3,
          overflow: 'hidden'
        }}>
          {/* Enhanced Toolbar Section */}
          <Paper
            elevation={0}
            sx={{
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              p: 2,
              borderBottom: '1px solid #e0e0e0'
            }}
          >
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} sm={6} lg={6} md={6} xl={6}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      background: '#1976d2'
                    }}
                  >
                    <FilterList sx={{ fontSize: 16, color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle1" sx={{ color: '#333', fontWeight: 600 }}>
                      Search & Filter
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.75rem' }}>
                      Find administrators by name, email, or role
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6} lg={6} md={6} xl={6} sx={{ justifyContent: 'flex-end', alignItems: 'center', display: 'flex' }}>
                <Button 
                  variant='contained' 
                  onClick={() => navigate('/dashboard/adminUserRole/create')} 
                  sx={{ 
                    height: 'max-content', 
                    marginRight: '24px !important', 
                    background: '#1976d2',
                    '&:hover': {
                      background: '#1565c0'
                    },
                    borderRadius: 2,
                    px: 2,
                    py: 1,
                    fontSize: '0.875rem'
                  }}
                  startIcon={<PersonAdd sx={{ fontSize: 16 }} />}
                >
                  Create Admin
                </Button>
              </Grid>
            </Grid>
            <Box sx={{ mt: 2 }}>
              <UserListToolbar 
                placeholder="Search Admins..." 
                numSelected={selected.length} 
                filterName={filterName} 
                onFilterName={handleFilter} 
              />
            </Box>
          </Paper>

          <div className="ag-theme-alpine" style={{ height: "500px", width: "100%" }}>
            <AgGridReact
              rowData={filteredUsers}
              treeData={false}
              animateRows={true}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              getDataPath={getDataPath}
              ref={gridRef}
              pagination={false}
              style={{fontSize:'16px'}}
              frameworkComponents={{
                EditButton,
              }}
            />
          </div>
        </Card>
      </Zoom>

      {/* Professional Stats Footer */}
      <Fade in timeout={1000}>
        <Paper
          elevation={0}
          sx={{
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            borderRadius: 3,
            p: 3,
            mt: 3,
            border: '1px solid #e0e0e0'
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  sx={{
                    width: 48,
                    height: 48,
                    background: '#1976d2'
                  }}
                >
                  <AdminPanelSettings sx={{ fontSize: 24, color: 'white' }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                    Total Admins
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    {list.length} system administrators
                  </Typography>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    background: '#4caf50'
                  }}
                >
                  <Security sx={{ fontSize: 20, color: 'white' }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                    Active Users
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    {list.filter(item => item.active).length} currently active
                  </Typography>
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    background: '#ff9800'
                  }}
                >
                  <Business sx={{ fontSize: 20, color: 'white' }} />
                </Avatar>
                <Box>
                  <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                    Role Types
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666' }}>
                    {new Set(list.map(item => item.role_designation)).size} different roles
                  </Typography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </Fade>
    </Container>
  )
}

export default AdminList;